import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { logoutT } from '../../utils/auth.util';
import './SideMenu.css';


const InvoiceIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" />
    <line x1="9" y1="7"  x2="15" y2="7" />
    <line x1="9" y1="11" x2="15" y2="11" />
    <line x1="9" y1="15" x2="13" y2="15" />
  </svg>
);

const CustomerIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9"  cy="7"  r="3" />
    <path d="M3 21v-2a5 5 0 0 1 5-5h2" />
    <circle cx="17" cy="10" r="3" />
    <path d="M21 21v-2a5 5 0 0 0-5-5h-1" />
  </svg>
);

const InvoiceBillIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="9" y1="13" x2="15" y2="13" />
    <line x1="9" y1="17" x2="13" y2="17" />
  </svg>
);

const ProfileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
  </svg>
);

const RestoreIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <polyline points="3 3 3 8 8 8" />
  </svg>
);

const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const navItems = [
  { to: '/',                label: 'Invoice',          icon: <InvoiceIcon /> },
  { to: '/customer',        label: 'Customer',         icon: <CustomerIcon /> },
  { to: '/invoicebill',     label: 'Invoice Bill',     icon: <InvoiceBillIcon /> },
  { to: '/profile',         label: 'Profile',          icon: <ProfileIcon /> },
  { to: '/customerRestore', label: 'Customer Restore', icon: <RestoreIcon /> },
];

const SideMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setIsOpen(false); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <>
      {!isOpen && (
        <button className="hamburger-btn" onClick={() => setIsOpen(true)} aria-label="Open menu">
          &#9776;
        </button>
      )}

      {isOpen && (
        <>
          <div className="sidebar-overlay" onClick={() => setIsOpen(false)} />
          <div className="side-menu">
            <div className="sidebar-brand">
              <button className="sidebar-close-btn" onClick={() => setIsOpen(false)} aria-label="Close menu">
                &#10005;
              </button>
              <h2>Sri Sendhur Tex</h2>
            </div>

            <div className="sidebar-divider" />

            <nav className="sidebar-nav">
              {navItems.map(({ to, label, icon }) => (
                <NavLink key={to} to={to} end={to === '/'}>
                  <span className="nav-icon">{icon}</span>
                  {label}
                </NavLink>
              ))}
            </nav>

            <div className="sidebar-footer">
              <button className="logout-btn" onClick={logoutT}>
                <span className="nav-icon logout-icon"><LogoutIcon /></span>
                Logout
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};



export default SideMenu;
